import "./App.css";
// import Header from "./components/header/Header";
import Home from "./components/home/Home";
import About from "./components/about/About";
import Skills from "./components/skills/Skills";
import Contact from "./components/contact/Contact";
import Footer from "./components/footer/Footer";
import ScrollUp from "./components/scrollup/ScrollUp";
import Work from "./components/work/Work";
import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import Verification from "./components/verification/Verification";
import Experience from "./components/experience/Experience";
import Achievement from "./components/achievement/Achievement";
import Header from "./components/header/Header";
import { BrowserRouter as Router } from "react-router-dom";

function App() {
  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);

  return (
    <Router>
      <Header />
      <main className="main">
        <Home />
        <About />
        <Skills />
        <Work />
        {/* <Experience /> */}
        <Verification />
        <Achievement />
        <Contact />
      </main>
      <Footer />
      <ScrollUp />
    </Router>
  );
}

export default App;
